
import { Component, Vue } from "vue-property-decorator";
import CategoriaTramites from "@/components/Tramites/CategoriaTramites.vue";

@Component({
  components: {
    CategoriaTramites
  }
})
export default class CategoriaTramitesView extends Vue {}
